import * as React from "react";
import {PROVISIONAL_HATCH_STYLE} from "../chart/provisional";

type PeriodTableLegendProps = {
    provisionalLabel: string
    note?: string
};

/**
 * The footer of a table of months: explains the hatching of provisional values.
 */
const PeriodTableLegend: React.FC<PeriodTableLegendProps> = ({provisionalLabel, note}) => (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-gray-200 px-4 py-3 sm:px-6 text-xs text-gray-500">
        <span className="flex items-center gap-2">
            <span className="inline-block h-4 w-8 rounded-sm border border-gray-200" style={PROVISIONAL_HATCH_STYLE}/>
            <span className="italic">{provisionalLabel}</span>
        </span>
        {note && <span>{note}</span>}
    </div>
);

export default PeriodTableLegend;
